(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (!customElements.get('allround-category-catalog')) {
    customElements.define('allround-category-catalog', class extends HTMLElement {
      connectedCallback() {
        if (this.loading) return;
        this.loading = true;
        this.loadRemaining();
      }

      async loadRemaining() {
        const visited = new Set();
        while (this.isConnected) {
          const link = this.querySelector('[data-catalog-next]');
          if (!link) break;
          const url = new URL(link.href);
          url.hash = '';
          url.searchParams.set('section_id', this.dataset.sectionId);
          if (visited.has(url.href)) break;
          visited.add(url.href);
          link.setAttribute('aria-busy', 'true');
          try {
            const response = await fetch(url);
            if (!response.ok) throw new Error('Catalog request failed');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const incoming = html.querySelector('allround-category-catalog');
            if (!incoming) throw new Error('Catalog markup missing');
            for (const category of this.querySelectorAll('.catalog-category')) {
              const incomingCategory = incoming.querySelector('#' + category.id);
              const grid = category.querySelector('.catalog-category__grid');
              const existingIds = new Set([...grid.children].map(card => card.dataset.productId));
              for (const card of incomingCategory?.querySelectorAll('.catalog-category__grid > li') || []) {
                if (!existingIds.has(card.dataset.productId)) {
                  grid.append(document.importNode(card, true));
                }
              }
              if (grid.children.length) {
                category.hidden = false;
                category.querySelector('.catalog-category__empty')?.remove();
              }
            }
            const next = incoming.querySelector('[data-catalog-next]');
            if (next) link.href = next.href;
            else link.remove();
          } catch {
            link.removeAttribute('aria-busy');
            break; // The normal pagination link stays usable if the request fails.
          }
        }
        this.loading = false;
      }
    });
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('.collection-category-nav__link');
    if (!link) return;
    const target = new URL(link.href);
    if (target.pathname !== location.pathname || !target.hash) return;
    const nav = link.closest('.collection-category-nav');
    for (const item of nav.querySelectorAll('a')) {
      const active = item === link;
      item.classList.toggle('collection-category-nav__link--active', active);
      if (active) item.setAttribute('aria-current', 'location');
      else item.removeAttribute('aria-current');
    }
  });


  } catch(e) { console.error(e); }
})();
})();
